<template>
  <ManagementPage :pageName="$t('Data') + ' / ' + $t('GlobalSearch')" grid>
    <template v-slot:top-left>
      <global-search-form />
    </template>

    <template v-slot:bottom-left>
      <global-search-map />
    </template>

    <template v-slot:top-right>
      <global-search-results />
    </template>

    <template v-slot:bottom-right>
      <global-search-workspaces />
    </template>
  </ManagementPage>
</template>

<script>
import ManagementPage from "@/newComponents/_Organisms/ManagementPage.vue";
import { mapActions } from "vuex";
import { bus } from "@/main.js";
import { checkPermissionsMixin } from "@/mixins/checkPermissionsMixin";
import GlobalSearchForm from "@/newComponents/WorkspacesManagement/GlobalSearch/GlobalSearchForm.vue";
import GlobalSearchMap from "@/newComponents/WorkspacesManagement/GlobalSearch/GlobalSearchMap.vue";
import GlobalSearchResults from "@/newComponents/WorkspacesManagement/GlobalSearch/GlobalSearchResults.vue";
import GlobalSearchWorkspaces from "@/newComponents/WorkspacesManagement/GlobalSearch/GlobalSearchWorkspaces.vue";

export default {
  name: "GlobalSearchView",

  props: ["pageName", "menu"],

  components: {
    ManagementPage,
    GlobalSearchForm,
    GlobalSearchMap,
    GlobalSearchResults,
    GlobalSearchWorkspaces,
  },

  mixins: [checkPermissionsMixin],

  data() {
    return {
    }
  },

  methods: {

  },
};
</script>

<style scoped>
.main-container {
  width: 100vw;
  height: 100vh;
  position: relative;
  background-color: #fafbfc;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}

.searchContainer {
  display: flex;
  align-items: center;
}

.temporatyLeft {
  width: 66%;
  height: 100%;
}

.tabs-custom {
  display: flex;
  flex-direction: column;
  justify-content: flex-start !important;
}

.span-custom {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 4px 20px 4px 20px;
  color: #767676;
  font-family: Lato;
  font-size: 0.625rem;
  font-style: normal;
  font-weight: 400;
  line-height: 0.9375rem; /* 150% */
}

.buttons-container-custom {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.cancel-button-custom {
  background: transparent;
  border-radius: 0.25rem;
  border: 0.609px solid #29bdf0;
}
.leftCardContainer {
  width: 100%;
  height: 100%;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0px 3.25104px 3.25104px 0px rgba(0, 0, 0, 0.25);
  padding: 20px 28px;
}

.actionsContainer {
  display: flex;
  align-items: center;
  gap: 3px;
}

.leftTitle {
  color: #767676;
  font-family: Lato;
  font-size: 10px;
  font-style: normal;
  font-weight: 800;
  line-height: 20px; /* 200% */
  text-transform: uppercase;
}

.rightSideTitleActions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.layer-search {
  flex: 0 0 auto;
  font-size: 12px;
  margin-right: 5px;
}

.layers-search .v-input__slot {
  min-height: 0 !important;
}

.layers-search .v-label {
  top: 4px !important;
  font: normal normal normal 12px/16px Segoe UI;
  color: #b1b6b9;
}
</style>



// WEBPACK FOOTER //
// src/views/GlobalSearchView.vue